import { PivotTableWidgetConfig } from './PivotTableWidget.types'

export default function (config: PivotTableWidgetConfig) {
    return {
        selection: [],
        sortBy: config?.sortBy,
        sortDirection:
            config?.sortDirection === 'descending'
                ? ('desc' as const)
                : config?.sortDirection === 'ascending'
                ? ('asc' as const)
                : undefined,
    }
}
